// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false;

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Bridge from './bridge/bridge.js'
Vue.prototype.$bridge = Bridge

// elementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, {});

import 'style/common.scss';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created() {
    // 路由兼容
    if (process.env.NODE_ENV !== 'start' && window.location.href.indexOf('/#/') !== -1) {
      // 删除路由中hash
      let href = window.location.href
      let href_arr = href.split('/#')
      window.location.replace(href_arr[0] + href_arr[1])
    }
  }
})




// WEBPACK FOOTER //
// ./src/main.js